import { ReactNode } from 'react'

type FormSectionProps = {
  title?: string
  subtitle?: string
  children: ReactNode
  actions?: ReactNode
  /** Shown in the top right corner, beside the title. */
  headerAside?: ReactNode
}

const FormSection = ({
  title,
  subtitle,
  children,
  actions,
  headerAside,
}: FormSectionProps) => {
  const heading = (
    <>
      <h3>{title}</h3>
      {subtitle && <div className="card-sub">{subtitle}</div>}
    </>
  )


  return (
    <div className="account-section">
      <>
        {headerAside ? (
          <div className="account-section-head">
            <div>{heading}</div>
            <div className="account-section-aside">{headerAside}</div>
          </div>
        ) : (
          heading
        )}
        <div className="account-section-body">{children}</div>
      </>
      {actions && (
        <div className="account-section-actions">
          {actions}
        </div>
      )}
    </div>
  )
}

export default FormSection